
import axios from 'axios';
import router from '../router';
import store from '../store';

// HTTP without authentication
export const httpNoAuth = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
    'national-id': process.env.VUE_APP_NATIONAL_ID
  },
});

// HTTP with authentication
export const httpAuth = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
    'national-id': process.env.VUE_APP_NATIONAL_ID
  },
});

// Handle Global Error Handler
// httpNoAuth.interceptors.response.use((response) => response, (error) => {
//   const { status } = error.response || { status: 520 };

//   // if (status === 401) {
//   //   // Not Authorized, redirect to login
//   //   store.commit('user/logout');
//   //   // store.commit('loading', false); TODO: loading
//   //   router.replace('/login');
//   // }

//   if (status === 520) {
//     // Unknown error handler
//     throw new Error(`An unexpected error happened: ${error}`);
//   }

//   return Promise.reject(error);
// });
